/**
 * Created by lihanying on 2017/6/29.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import { message } from 'antd'
import { GETADVERTLIST, GETADVERTSETTING } from './constants'

export const getAdvertList = (payload) => {
  return {
    type: GETADVERTLIST,
    payload,
  }
}

export const getAdvertSetting = (payload) => {
  return {
    type: GETADVERTSETTING,
    payload,
  }
}

/*广告列表*/
export function fetchAdvertList(club) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/AdList`
    return fetchData(endpoint).then((data) => {
      dispatch(getAdvertList(data.list))
      return data
    })
  }
}

/*禁止显示广告*/
export function stopAd(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/StopAd`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        dispatch(fetchAdvertList())
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
    })
  }
}

/*是否显示广告*/
export function displayAd(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/DisplayAd`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        dispatch(fetchAdvertList())
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
    })
  }
}

/*删除广告*/
export function delAd(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/DelAd`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        dispatch(fetchAdvertList(body.club_id))
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
    })
  }
}

/*修改和添加广告*/
export function updateAd(body, callback) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/UpdateAd`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        dispatch(fetchAdvertList(body.club_id))
        message.success(data.detail)
        callback && callback()
      } else {
        message.error(data.detail)
      }
    })
  }
}

/*排序*/
export function updateOrder(body, callback) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/UpdateOrder`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        dispatch(fetchAdvertList(body.club_id))
        message.success(data.detail)
        callback && callback()
      } else {
        message.error(data.detail)
      }
    })
  }
}

/*获取设置*/
export function fetchAdvertSetting() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/SettingAd`
    return fetchData(endpoint).then((data) => {
      if (!data) {
        data = {
          display_time: '',
          picture: '0',
          video: '0',
          numbers: '',
          club_id: '0',
        }
      }
      dispatch(getAdvertSetting(data))
    })
  }
}

/*修改设置*/
export function advertSetting(body, callback) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/SetClubApi/SettingAd`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        message.success(data.detail)
        callback && callback()
      } else {
        message.error(data.detail)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/AdvertManage/action.js